module.exports = __webpack_public_path__ + "band_9_son.f74b572f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/child_to_parent/band_9_son.png
// module id = +seM
// module chunks = 0